module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder"
  }, [_c('el-table', {
    ref: "arrdata",
    staticClass: "tbPoint",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.check
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "firmwareName",
      "label": _vm.$t('lin_global.name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "version",
      "label": _vm.$t('lin_global.version'),
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.status'),
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('span', {
          staticStyle: {
            "color": "#8492A6"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.waitOne')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('span', {
          staticStyle: {
            "color": "#F7BA2A"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.waitTwo')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('span', {
          staticStyle: {
            "color": "#13CE66"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.verifyPass')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('span', {
          staticStyle: {
            "color": "#FF4949"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.verifyNotPass')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": _vm.$t('terminal.details.animatType'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechanismName",
      "label": _vm.$t('lin_global.label_areaid')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "downloads",
      "label": _vm.$t('lin_global.downNumber'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.ope'),
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_verify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('i', {
          staticClass: "fa fa-check-square-o"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.pageSized,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-077ce9e5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/firmware/check.vue
// module id = 958
// module chunks = 0